import React from 'react';

export default function AddtnlText() {
    return (
        <div className="container mt-5 mb-5">
            <div className="row">
                <div className="col-12">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                    <button className="btn btn-warning mt-3">SEE MORE</button>
                </div>
            </div>
        </div>
    );
}
